import Model from '@/models/Model'

export default class WhDispatchRequest extends Model {
    resource() {
        return 'wh_dispatch_request'
    }
}
